import Skeleton from '@/components/base/skeleton/skeleton';
import { clsx } from 'clsx';

interface SkeletonProps {
  className?: string;
}

const TextSkeleton = ({ className }: SkeletonProps) => (
  <Skeleton className={clsx('my-[0.25em] h-[1em]', className)} />
);

export default TextSkeleton;
